import styled from 'styled-components';
import { ErrorMessage } from 'formik';

export default styled(ErrorMessage)`
  font-size: 80%;
  margin-top: ${(props) => (props.noMargin ? '0' : '-1em')};
  color: #c4262e;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
`;
